import React, { useEffect } from 'react';
import {
  IMarketplaceTilesLocation,
  IMarketplaceTilesLocationValue,
  MarketplaceTilesType,
} from 'src/typings/marketplace';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  TileLocationCity,
} from 'src/components/profileComponents/Marketplace/components/ProjectsTiles/compopents/TileLocationCity';
import Box from '@mui/material/Box';
import {
  TileLocationMetroStation,
} from 'src/components/profileComponents/Marketplace/components/ProjectsTiles/compopents/TileLocationMetroStation';
import {
  TileLocationDistrict,
} from 'src/components/profileComponents/Marketplace/components/ProjectsTiles/compopents/TileLocationDistrict';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { translations } from 'src/constants/translations';
import { IOSSwitch } from 'src/components/SwitchIos';
import { ReactSortable, Sortable, Store } from 'react-sortablejs';
import { useStyles } from './styles';

interface Props {
  item: IMarketplaceTilesLocation
  lang: string;
  onChange: (item: IMarketplaceTilesLocation) => void,
}

export const TileLocation: React.FC<Props> = ({
  item, lang, onChange,
}) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  useEffect(() => {
    setRocketState(item.isActive);
  }, [item]);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  const updateValue = (updatedValue: IMarketplaceTilesLocationValue) => {
    onChange({
      ...item,
      values: item.values.map((value) => (value.id === updatedValue.id ? updatedValue : value)),
    });
  };

  return (
    <Box style={{ backgroundColor: 'white' }}>
      <GroupWrapper
        name="Location"
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => setCollapseState(state)}
          />
        )}
      >
        { collapseState === GroupWrapperCollapseState.OPEN && (
          <>
            <div className={styles.description}>
              <p>{translations.locationDescription}</p>
            </div>
            <ReactSortable
              animation={150}
              handle=".drag-handle"
              list={item.values.map((value) => ({ ...value, chosen: false }))}
              setList={(newList, sortable: Sortable | null, store: Store) => {
                if (store && store.dragging && store.dragging.props && JSON.stringify(store.dragging.props.list) !== JSON.stringify(newList)) {
                  const orderedList = newList.map((listItem, index) => ({ ...listItem, sortOrder: index }));
                  onChange({ ...item, values: [...orderedList] });
                }
              }}
            >
              {item.values.map((value) => (
                <Box mb={8} key={value.id}>
                  { value.diType === MarketplaceTilesType.CITY && (
                    <TileLocationCity
                      item={value}
                      lang={lang}
                      onChange={updateValue}
                    />
                  ) }
                  { value.diType === MarketplaceTilesType.METROSTATION && (
                    <TileLocationMetroStation
                      item={value}
                      lang={lang}
                      onChange={updateValue}
                    />
                  ) }
                  { value.diType === MarketplaceTilesType.DISTRICT && (
                  <>
                    <TileLocationDistrict
                      item={value}
                      lang={lang}
                      onChange={updateValue}
                    />
                    <div className={styles.metroOrDistrict}>
                      <div className={styles.optionSwitch}>
                        { translations.metroOrDistrict }
                        <IOSSwitch
                          defaultChecked={item.isMetroOrDistrict}
                          onChange={(e: any) => {
                            onChange({ ...item, isMetroOrDistrict: e.target.checked });
                          }}
                        />
                      </div>
                      <div className={styles.description}>
                        <p>{translations.districtDescription}</p>
                      </div>
                    </div>
                  </>
                  ) }
                </Box>
              ))}
            </ReactSortable>
          </>
        ) }
      </GroupWrapper>
    </Box>
  );
};
